// eslint-disable-next-line no-unused-vars
import * as ButtonTypes from './Button.types';

/**
 * Button colors for each variant, to be used in the useStyles function, can be extended to include more variants
 * @type {Record<ButtonTypes.ColorVariant, ButtonTypes.ButtonColor>}
 */
const BUTTON_COLORS = {
  "secondary-light": {
    text: 'text-white',
    background: 'bg-black',
    hoverBackground: 'hover:bg-neutral-600',
    activeBackground: 'active:bg-neutral-700',
  },
  "primary": {
    text: 'text-white',
    background: 'bg-boost-primary-500',
    hoverBackground: 'hover:bg-boost-primary-400',
    activeBackground: 'active:bg-boost-primary-600',
  },
  "secondary-text-only": {
    text: 'text-black',
    background: 'bg-transparent',
    hoverBackground: 'hover:bg-neutral-200',
    activeBackground: 'active:bg-neutral-300',
  },
};

/**
 *
 * @param {ButtonTypes.ColorVariant} variant
 */
const getButtonColors = (variant) => {
  return BUTTON_COLORS[variant];
};

export const useStyles = (variant) => {
  const colors = getButtonColors(variant);
  return `rounded text-center text-base w-full h-10 px-4 ${colors.background} ${colors.hoverBackground} ${colors.activeBackground} ${colors.text}`;
};